module.exports = __webpack_public_path__ + "img/experience-bar-fill.691be889.png";